import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: 62px;
  background-color: #ffffff;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  border: 2px solid #c9c9c9;
  display: flex;
  flex-direction: row;
  @media (max-width: 1100px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Left = styled.div`
  cursor: pointer;
  margin-left: 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  @media (max-width: 1113px) {
    margin-left: 10px;
    justify-content: flex-start;
  }
`;

export const Right = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  @media (max-width: 1113px) {
    justify-content: flex-end;
  }
`;

export const Legend = styled.div`
  font-size: 14px;
  color: #7f7f7f;
  margin-right: 6px;
`;

export const ItemDetails = styled.span`
  display: flex;
  color: #808080;
  font-size: 14px;
  font-weight: 300;
  margin-left: 27px;
  margin-right: 34px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const Details = styled.div`
  margin-left: 24px;
  padding: 0px 10px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #fff;
  font-size: 12px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
`;

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5,
};
